type StepLabel = "Configure Target" | "Edit Table Mapping" | "Validate Target" | "Review";
type StepDetail = {
    id: StepLabel;
    stepName: string;
    transient?: boolean; // optional, as not all steps have it
};
export type StepDetailObj = {
    ConfigureTarget: StepDetail;
    TableMappingEditor: StepDetail;
    ValidateTarget: StepDetail;
    Review: StepDetail;
}

export const stepDetails: StepDetailObj = {
    ConfigureTarget: { id: "Configure Target", stepName: "configure-target" },
    TableMappingEditor: { id: "Edit Table Mapping", stepName: "table-mapping-editor", transient: true },
    ValidateTarget: { id: "Validate Target", stepName: "validate-target", transient: true },
    Review: { id: "Review", stepName: "review" }
};

type StepKey = keyof typeof stepDetails;

type Steps = Record<StepKey, StepLabel>;

export const Steps: Steps = {
    ConfigureTarget: stepDetails.ConfigureTarget.id,
    TableMappingEditor: stepDetails.TableMappingEditor.id,
    ValidateTarget: stepDetails.ValidateTarget.id,
    Review: stepDetails.Review.id
};

export const getStepID = (urlstepName: string): string | undefined => {
    const requiredKey = Object.keys(stepDetails).find(key => {
        return stepDetails[key]["stepName"] === urlstepName;
    });
    if (!requiredKey) {
        console.error("Step not found");
    }

    return Steps[requiredKey as StepKey];
};

export const getCurrentStepHeader = (step: StepLabel, target?: string): string => {
    switch (step) {
        case Steps.ConfigureTarget:
            return target ? `Configure ${target || ""} as Target` : `Configure Target`;
        case Steps.TableMappingEditor:
            return `Edit Table Mapping (Optional)`;
        case Steps.ValidateTarget:
            return `Validating Target and Checking Environment`;
        case Steps.Review:
            return Steps.Review;
        default:
            return step;
    }
};

export const getCurrentStepSubHeader = (step: StepLabel, target?: string): string => {
    switch (step) {
        case Steps.ConfigureTarget:
            return `Please fill in the connection details so we can check if Striim is able to reach your ${target ||
                ""} target`;
        case Steps.TableMappingEditor:
            return `If the automatically generated mapping is not appropriate, click Edit and revise it as necessary.`;
        case Steps.ValidateTarget:
            return `Before we can proceed to the next steps, we'll need to make sure Striim is able to access your target.
            Striim will fetch additional information about your target to help you in the next steps.
            Depending on the size of your target and the network latency, this may take a few minutes.`;
        case Steps.Review:
        default:
            return "";
    }
};
